import { gql } from 'graphql-tag';

export const GET_PAYABLES_BUCKETS_STATS = gql`
  query Idf0a60c1679e4303249b4d81a57fcbd43(
    $companyId: ID!
    $filtersV2: JSON
    $withProofFiltersV2: JSON
    $withoutProofFiltersV2: JSON
    $missingProofFiltersV2: JSON
    $textualSearch: String
    $includeFiltered: Boolean!
    $includeWithProof: Boolean!
    $includeWithoutProof: Boolean!
    $includeMissingProof: Boolean!
  ) {
    __typename
  }
`;

export function makeGetPayablesBucketsStatsVariables({
  companyId,
  filtersV2,
  withProofFiltersV2,
  withoutProofFiltersV2,
  missingProofFiltersV2,
  textualSearch,
}: {
  // companyId is optional to allow usage in organisation-reporting
  // when other companyId is used, the query returns only if the
  // auth user is controller on that company.
  // If not passed the companyId variable is inserted automatically as
  // the current companyId
  companyId?: string;
  filtersV2?: Record<string, unknown>;
  withProofFiltersV2?: Record<string, unknown>;
  withoutProofFiltersV2?: Record<string, unknown>;
  missingProofFiltersV2?: Record<string, unknown>;
  textualSearch?: string;
}) {
  return {
    ...(companyId && { companyId }),
    filtersV2: filtersV2 || null,
    withProofFiltersV2: withProofFiltersV2 || null,
    withoutProofFiltersV2: withoutProofFiltersV2 || null,
    missingProofFiltersV2: missingProofFiltersV2 || null,
    textualSearch: textualSearch || '',
    includeFiltered: filtersV2 !== undefined,
    includeWithProof: withProofFiltersV2 !== undefined,
    includeWithoutProof: withoutProofFiltersV2 !== undefined,
    includeMissingProof: missingProofFiltersV2 !== undefined,
  };
}
